import { useMemo } from 'react'

export const useFilterExchangeWhitelist = (exchangeWhitelist) => {
  const filteredWhitelist = useMemo(() => {
    return exchangeWhitelist.outgoing
  }, [exchangeWhitelist])
  return filteredWhitelist
}
